import { useSearch } from '@tanstack/react-router';

/** The election and date a reading is taken at, `?election=&asOf=`.
 *
 *  `localityRef` (`?locality=`) is read by Sentimento only: Território takes
 *  its locality from the campaign record's `scope.place_id`, since the
 *  locality is the campaign's own electoral scope and never picked. */
export interface TerritorySelection {
  electionId: string | null;
  asOf: string | null;
  localityRef: string | null;
}

function text(value: unknown): string | null {
  return typeof value === 'string' && value !== '' ? value : null;
}

export function useTerritorySelection(): TerritorySelection {
  const { election, asOf, locality } = useSearch({ strict: false }) as Record<string, unknown>;
  return { electionId: text(election), asOf: text(asOf), localityRef: text(locality) };
}
